<template>
  <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title="model.id > 0 ? '编辑' : '新建'"
      width="800px"
      top="1vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        class="form"
        :model="model"
        label-width="auto">
      <el-form-item prop="fileName" label="文件名" :rules="$rule.notNull">
        <el-input v-model.trim="model.fileName" :disabled="!model.fileKey" clearable/>
      </el-form-item>
      <el-form-item prop="fileKey" label="图片" :rules="$rule.notNull">
        <el-image
            v-if="model.filePath"
            style="width: auto; height: 100px;"
            :src="model.filePath"
            fit="contain"
            :preview-src-list="[model.filePath]">
          <div slot="placeholder">
            <i class="el-icon-loading"/>
          </div>
        </el-image>
      </el-form-item>
      <el-form-item prop="filePath" label="文件路径" :rules="$rule.notNull">
        <el-input v-model.trim="model.filePath" readonly/>
      </el-form-item>
      <el-form-item prop="note" label="描述">
        <el-input
            v-model="model.note"
            placeholder="请输入描述"
            type="textarea"
            autosize
            maxlength="500"
            show-word-limit/>
      </el-form-item>
      <el-upload
          :action="uploadUrl"
          :headers="uploadHeaders"
          :before-upload="beforeUpload"
          :on-error="handlerError"
          :on-success="handleSuccess"
          drag
          :show-file-list="false"
          accept=".png,.jpg,.jpeg">
        <i class="el-icon-upload"/>
        <div class="el-upload__text">将文件拖到此处，或<em>{{model.id > 0 ? '点击替换' : '点击上传'}}</em></div>
        <div slot="tip" class="el-upload__tip">只能上传.png,.jpg,.jpeg文件</div>
      </el-upload>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>

  import loginUtil from "@/util/loginUtil";

  export default {
    name: "MaterialLabelPrintImageEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        uploadLoading: false,
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        uploadUrl: window.config.basicServerUrl + "files/uploadPublicFile",
        model: {
          id: null,
          fileName: "",
          fileKey: "",
          filePath: "",
          note: "",
        },
      };
    },
    methods: {
      open(row) {
        if (row) {
          this.model = JSON.parse(JSON.stringify(row));
        }
        this.dialogVisible = true;
      },
      beforeUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (![".png", ".jpg", "jpeg"].includes(lastName.toLowerCase())) {
          this.$message.error("请上传.png,.jpg,.jpeg文件类型");
          return false;
        }
        return true;
      },
      handleSuccess(res, file) {
        this.model.fileName = file.name;
        this.model.fileKey = res.data;
        this.model.filePath = res.data;
        this.$message.success("上传成功");
      },
      handlerError() {
        this.$message.error("上传失败");
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "materialLabelPrints/image", this.model)
              .then(res => {
                if (res.success) {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .finally(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style scoped>
</style>
